import { Chart } from "react-google-charts"

export const data = [
    ["Country", "Freight Value(M)"],
    ["India", 11],
    ["USA", 2],
    ["Singapore", 2],
    ["China", 2],
    ["UK", 7],
];

export const options = {
    title: "Contry-wise Freight Exports",
};

export function C1() {
    return (
        <>
            <div className="columns">
                <div className="columns is-one-quarter">
                    <Chart
                        chartType="PieChart"
                        data={data}
                        options={options}
                        width={"100%"}
                        chartEvents={[
                            {
                              eventName: "ready",
                              callback: ({ chartWrapper, google }) => {
                                const chart = chartWrapper.getChart();
                                google.visualization.events.addListener(chart, "onmouseover", e => {
                                  const { row, column } = e;
                                  //console.warn("MOUSE OVER ", { row, column }, e);
                                });
                                google.visualization.events.addListener(chart, "onmouseout", e => {
                                  const { row, column } = e;
                                  //console.warn("MOUSE OUT ", { row, column }, e);
                                });
                                google.visualization.events.addListener(chart, "click", e => {
                                    console.warn("MOUSE CLICK ", e);
                                  });
                              }
                            }
                          ]}
                    />
                </div>
                <div className="columns is-one-quarter">
                    <Chart
                        chartType="PieChart"
                        data={data}
                        options={options}
                        width={"100%"}
                    />
                </div>
                <div className="columns is-one-quarter">
                    <Chart
                        chartType="PieChart"
                        data={data}
                        options={options}
                        width={"100%"}
                    />

                </div>
                <div className="columns is-one-quarter">
                    <Chart
                        chartType="PieChart"
                        data={data}
                        options={options}
                        width={"100%"}
                    />

                </div>
                <div className="columns is-one-quarter">
                    <Chart
                        chartType="PieChart"
                        data={data}
                        options={options}
                        width={"100%"}
                    />

                </div>
                <div className="columns is-one-quarter">
                    <Chart
                        chartType="PieChart"
                        data={data}
                        options={options}
                        width={"100%"}
                    />

                </div>
            </div>
        </>
    )
}
